/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { ReactNode } from 'react';

import { DataTable, DataTableProps } from 'primereact/datatable';
import 'primereact/datatable/datatable.min.css';
import { TApplication } from '@marketplace/api';

import { PaginationTemplate } from './paginations-template/pagination';

import cn from 'classnames';
import classes from './table.module.scss';

type TTable = DataTableProps & {
  rootClassName?: string;
  children: ReactNode;
};
const INREVIEW = 'In-Review';

export const Table = (props: TTable) => {
  const rowClass = (item: TApplication) => {
    return {
        'p-row-bold': item.status === INREVIEW
    };
};
  return (
    <div className={cn(classes.root, props.rootClassName)}>
      <DataTable
        value={props.value}
        paginator={props.paginator}
        totalRecords={props.totalRecords}
        lazy={props.lazy}
        first={props.first}
        rows={props.rows}
        onPage={props.onPage}
        onSort={props.onSort}
        onFilter={props.onFilter}
        onRowClick={props.onRowClick}
        header={props.header}
        footer={props.footer}
        className={props.className}
        tableStyle={props.tableStyle}
        tableClassName={props.tableClassName}
        rowClassName={rowClass}
        // @ts-ignore
        paginatorTemplate={PaginationTemplate}
        {...props}
      >
        {props.children}
      </DataTable>
    </div>
  );
};
